export default __webpack_public_path__ + "static/media/craon22.0ffa5487.jpg";